enum AssetSubtype {
    MARINE_HULL = 'marine_hull',
    MARINE_ENGINE = 'marine_engine',
    TRAILER = 'trailer',
}

export default AssetSubtype
